// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'

// ElementUI
import ElementUI from 'element-ui'
// 组件
import components from '@/components/index.js'
// 样式
import '@/styles/index.js'
import '@/assets/iconfront/iconfont.css'
import '@/assets/iconfront/iconfont.js'
import '@/assets/iconFronts/iconfont.css'
import '@/assets/iconFronts/iconfont.js'
// filters验证方法
import * as filters from '@/utils/filters/index.js'
import { price } from '@/utils/filters/index.js'
// 混入
import mixins from '@/common/mixin/index.js'
// cookies
import Cookies from 'js-cookie'
// 引入common.js
import * as commonJs from '@/utils/common.js'
import VueClipboard from 'vue-clipboard2'
import { Base64 } from 'js-base64'// form 表单校验
import system from '@/utils/system'

window.addEventListener('beforeunload', () => {
  // 清除cookies
  Cookies.remove('SESSION');
});

// ElementUI.Dialog.props.lockScroll.default = false
Vue.use(ElementUI)
Vue.use(components)
Vue.filter('thousandthMoney', price)
Vue.use(mixins)

Vue.prototype.$commonJs = commonJs
Vue.prototype.$filters = filters
Vue.prototype.Cookies = Cookies
Vue.prototype.Base64 = Base64
Vue.prototype.system = system

Vue.config.productionTip = false

Vue.use(VueClipboard)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
// console.log(process.env.NODE_ENV)



// WEBPACK FOOTER //
// ./src/main.js